<template>
<div>
  <div v-if="enterFavsIsVisible" style="width: 100%; display: flex; flex-direction: column; align-items: center; padding: 10px; text-align: center"">
    <p style="font-size: .8rem; text-align: center">Encuentra autos nuevos y seminuevos y guardalos para decidir más tarde.</p>
    <button style="margin: 20px 0; background: #DBFE54; border: none; border-radius: 5px; font-weight: bold; padding: 8px 16px; font-size: .8rem"
    @click="showSignInModal">Ingresar a mis favoritos</button>
    <a href="" style="text-decoration: underline; font-size: .8rem; color: #000"
    @click.prevent="showSignUpModal">Registrarme</a>
  </div>
  <div v-if="isSignUpModalVisible" class="auth-modal">
    <div>
        <a class="close-auth-modal" @click="isSignUpModalVisible = !isSignUpModalVisible">&times;</a>
    </div>
    <div v-if="isSignUpModalFormVisible" class="auth-modal-body signup-modal-body">
        <h3>Crear cuenta</h3>
        <form class="tx-white" @submit.prevent="signUpUser" autocomplete="off">
            <div>
                <label for="full_name">Nombre completo</label>
                <input id="full_name" type="text"  
                :class="{'redish-input': signUpFormErrors.full_name}"
                v-model="signUpForm.full_name">
            </div>
            <div>
                <div style="display: flex; padding-bottom: 5px; align-items: center;">
                    <label for="cellphone" style="display: inline-block; margin-right: 5px;">Celular</label>
                    <img src="/images/whatsapp-icon.png" alt="" style="width: 20px">
                </div>
                <the-mask id="cellphone" type="tel"
                    :masked="false"
                    :class="{'redish-input': signUpFormErrors.cellphone}"
                    mask="##-##-##-##-##"
                    v-model="signUpForm.cellphone"
                    autocomplete="off" />
                <small v-if="!signUpFormErrors.cellphone">Enviaremos un código de verificación</small>
                <small v-else-if="signUpFormErrors.cellphone[0] == 'No whatsapp Account'" style="color: #dc3545">Ingresa un número con whatsapp</small>
                <small v-else="signUpFormErrors.cellphone[0]" style="color: #dc3545">{{ signUpFormErrors.cellphone[0] }}</small>
            </div>
            <div>
                <label for="password">Contraseña</label>
                <input id="password" 
                type="password"
                :class="{'redish-input': signUpFormErrors.password}"
                autocomplete="off"
                v-model="signUpForm.password">
                <small>Min 8 caracteres, una letra mayúscula, una mínuscula, un número y una caracter especial (._Q$#!)</small>
            </div>
            <button>Crear cuenta</button>
        </form>
    </div>
    <div v-else class="auth-modal-body whatsapp-validation-modal-body">
        <h3>Estamos creando tu cuenta</h3>
        <img src="/images/tube-spinner.svg" style="width: 50px;" alt="">
    </div>
  </div>
  <div v-if="isCodeValidationModalVisible" class="auth-modal">
      <div>
          <a class="close-auth-modal" @click="isCodeValidationModalVisible = !isCodeValidationModalVisible">&times;</a>
      </div>
      <div v-if="isCodeValidationModalFormVisible" class="auth-modal-body whatsapp-validation-modal-body">
          <h3>Ingresa el código de verificación que te enviamos por 
              <strong>Whatsapp</strong>
              <img src="/images/whatsapp-icon.png" alt="" style="width: 20px">
          </h3>
          <form class="tx-white" @submit.prevent="validateWhatsappCode" autocomplete="off">
              <div class="whatsapp-code-container">
                  <div class="vcode-input">
                      <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.first_input"/>
                  </div>
                  <div class="vcode-input">
                      <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.second_input"/>
                  </div>
                  <div class="vcode-input">
                      <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.third_input"/>
                  </div>
                  <div class="vcode-input">
                      <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.forth_input"/>
                  </div>
                  <div class="vcode-input">
                      <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.fifth_input"/>
                  </div>
                  <div class="vcode-input">
                      <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.sixth_input"/>
                  </div>
              </div>
              <small v-if="validationCodeError" style="color: #dc3545">El código es incorrecto, verificalo.</small>
              <button>Verificar</button>
          </form>
      </div>
      <div v-else class="auth-modal-body whatsapp-validation-modal-body">
          <h3>¡Todo listo!</h3>
          <img src="/images/success-check.png" style="width: 50px;" alt="">
          <button @click="isCodeValidationModalVisible = !isCodeValidationModalVisible"
          style="margin-top: 0px; background: lightgray;">Seguir viendo autos</button>
      </div>
  </div>
  <div  v-if="isSignInModalVisible" class="auth-modal">
      <div>     
          <a class="close-auth-modal" @click="isSignInModalVisible = !isSignInModalVisible">&times;</a>
      </div>
      <div class="auth-modal-body signup-modal-body">
        <template v-if="!signInIsLoadling">       
            <h3>Ingresar</h3>
            <form class="tx-white" @submit.prevent="signInUser" autocomplete="off">
                <div>
                    <div style="display: flex; padding-bottom: 5px; align-items: center;">
                        <label for="cellphone" style="display: inline-block; margin-right: 5px;">Celular</label>
                    </div>
                    <the-mask id="cellphone" type="tel"
                        :masked="false"
                        mask="##-##-##-##-##"
                        v-model="signInForm.cellphone"
                        autocomplete="off" />
                    <small v-if="signInFormErrors.cellphone" style="color: #dc3545">Este celular no está asociado a una cuenta, verifica la información</small>
                </div>
                <div>
                    <label for="password">Contraseña</label>
                    <input id="password" 
                    type="password"
                    autocomplete="off"
                    v-model="signInForm.password">
                    <small v-if="signInFormErrors.password" style="color: #dc3545">La contraseña es inválida, revisala y vuelve a intentar.</small>
                </div>
                <button style="margin: 40px auto">Ingresar</button>
                <a href="" style="text-decoration: underline; font-size: .8rem; margin: 0 auto; display: block;"
                @click.prevent="sendResetPasswordLink">Recuperar contraseña</a>
            </form>
        </template>
        <template v-else>
            <img src="/images/tube-spinner.svg" style="width: 50px;" alt="">
        </template>
      </div>
  </div>
</div>
</template>
<script>

import { bus } from '../../app'

export default {
    data() {
      return {
        favs: [],
        currencyFormat: Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'}),
        isAuthModalVisible: false,
        isSignUpModalVisible: false,
        isCodeValidationModalVisible: false,
        isCodeValidationModalFormVisible: false,
        isSignUpModalFormVisible: true,
        isSignInModalVisible: false,
        signUpForm: {
            full_name: '',
            cellphone: '',
            password: ''
        },
        signInForm: {
            cellphone: '',
            password: ''
        },
        validationCodeForm: {
            first_input: '',
            second_input: '',
            third_input: '',
            forth_input: '',
            fifth_input: '',
            sixth_input: '',
        },
        signUpFormErrors: {
            full_name: null,
            cellphone: null,
            password: null
        },
        signInFormErrors: {
            cellphone: null,
            password: null
        },
        signInIsLoadling: false,
        validationCodeError: false,
        isAuthenticated: false,
        enterFavsIsVisible: true,
      }
    },
    created() {
        bus.$on('likes-updated', this.likesUpdatedHandler);
    },
    mounted() {
      this.getFavs()
      this.isAuthenticated = document.getElementById('is_authenticated').value ? true : false
    },
    methods: {
        likesUpdatedHandler() {
            const likesArr = JSON.parse(localStorage.getItem('likes'))
            this.enterFavsIsVisible = likesArr.length > 0 ? false : true
        },
      async getFavs() {
        const storageFavs = JSON.parse(localStorage.getItem('likes'))

        try {
          const { data } = await axios.post('/favoritos', storageFavs)
          this.favs = data

        } catch (error) {
          console.error(error)
        }
      },
      deleteFav(fav) {
        const likes = JSON.parse(localStorage.getItem('likes'))
        const eIdx = likes.findIndex(e => e.mkt_vehicle_id == fav.mkt_vehicle_id || e.mkt_brand_new_vehicle_id == fav.mkt_brand_new_vehicle_id)
        this.favs.splice(eIdx, 1)
        likes.splice(eIdx, 1)
        localStorage.setItem('likes', JSON.stringify(likes))
      },
      showSignInModal() {
        this.isSignInModalVisible = !this.isSignInModalVisible
        this.isSignUpModalVisible = false
      },
      showSignUpModal() {
        this.isSignInModalVisible = false
        this.isSignUpModalVisible = !this.isSignUpModalVisible
      },
      async signUpUser() {
            this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
            try {                
                await axios.post('/auth/signup', this.signUpForm)
                localStorage.setItem('signup_cellphone', this.signUpForm.cellphone)
  
                this.isSignUpModalVisible = false
                this.isCodeValidationModalVisible = true
                this.isCodeValidationModalFormVisible = true
                this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
            } catch (error) {
                this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
                console.log(error.response);
                this.signUpFormErrors = error.response.data.errors
            }
        },
        async validateWhatsappCode() {
            const code = this.validationCodeForm.first_input +
            this.validationCodeForm.second_input + 
            this.validationCodeForm.third_input +
            this.validationCodeForm.forth_input +
            this.validationCodeForm.fifth_input +
            this.validationCodeForm.sixth_input;

            const cellphone = localStorage.getItem('signup_cellphone')

            try {                
                await axios.post('/auth/validate', {
                    cellphone: cellphone,
                    code: code
                })
                // this.isCodeValidationModalFormVisible = false
                this.validationCodeError = false
                window.location.href = '/perfil'
            } catch (error) {
                console.error(error);
                if(error.response.status == 400)
                this.validationCodeError = true
            }
        },
        signInUser() {
            this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
            try {
                console.log('TimeOPute');
                this.signInIsLoadling = true
                axios.post('/auth/login', this.signInForm)
                this.isAuthModalVisible = false
                // this.isSignInModalVisible = false

                var swal = this.$swal
                setTimeout(function() {
                    swal({
                        icon: 'success',
                        title: 'Ya estás logueado',
                        text: '',
                    })  
                }, 1000);

                setTimeout(() => {
                    window.location.href = '/perfil'
                }, 3000)

            } catch (error) {
                console.log(error.response);
                this.signInFormErrors = error.response.data.errors
                this.signInIsLoadling = false
            }
        },
        async sendResetPasswordLink() {
            console.log(this.signInForm.cellphone);
            if(!this.signInForm.cellphone || this.signInForm.cellphone.length < 10) alert('Ingresa el número de teléfono')
            try {                
                await axios.post('/auth/send-reset-link', this.signInForm)
                this.isAuthModalVisible = false
                this.isSignInModalVisible = false
            } catch (error) {
                console.log(error.response);
                this.signInFormErrors = error.response.data.errors
            }
        },
    },
  }
</script>
<style scoped>
.auth-modal {
    width: 90%;
    position: fixed;
    background: #000000dd;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    z-index: 99;
}

@media screen and (min-width: 1024px) {
    .auth-modal {
        width: 300px;
    }
}

.auth-modal > div > .close-auth-modal {
    float: right;
    color: #fff;
    font-size: 2.2rem;
    margin-right: 7px;
}

.auth-modal > div.auth-modal-body {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    padding: 0 40px 40px 40px;
}

.auth-modal > .auth-modal-body > *:not(:last-child) {
    margin-bottom: 30px;
}

.auth-modal > div.auth-modal-body button {
    width: 150px;
    padding: 8px 0;
    border-radius: 5px;
    border: none;
    font-size: 0.8rem;
    font-weight: bold;
}

.auth-modal > div.auth-modal-body > .login-button  {
    background: #DBFE54;
}

.auth-modal > div.auth-modal-body > .signup-button {
    background: #fff;
}

.auth-modal > div.auth-modal-body > h3 {
    font-size: .9rem;
}

.auth-modal > div.auth-modal-body > h3,a {
    text-align: center;
    color: #fff;
    font-weight: bold;
}

.auth-modal > div.auth-modal-body > a {
    text-decoration: underline;
    font-size: .8rem;
}

.auth-modal-body > form input {
    border-radius: 5px;
    width: 100%;
}

.signup-modal-body > form > div:not(:last-child) {
    margin-bottom: 15px;
}

.signup-modal-body > form >  {
    font-weight: bold;
}

.signup-modal-body > form > div > label {
    font-size: .9rem;
    display: block;
    margin-bottom: 5px;
}

.signup-modal-body > form > div > small {
    font-size: .7rem;
}

.signup-modal-body > form > button {
    display: block;
    margin: 0 auto;
    background: #DBFE54;
}
.redish-input {
    border-color:#dc3545;
    box-shadow: 0 0 0 .2rem rgba(220,53,69,.25);
}
.whatsapp-validation-modal-body button {
    background: #DBFE54;
    display: block;
    margin: 0 auto;
    margin-top: 50px;
}

.whatsapp-code-container {
    display: flex;
}

.whatsapp-code-container > .vcode-input:not(:last-child) {
    margin-right: 10px;
}

.vcode-input {
  position: relative;
}

.vcode-input > input[type=text] {
  background: transparent;
  border: none;
  border-bottom: solid 1px #DBFE54;
  padding: 5px;
  transition: padding 0.4s;
  color: #fff;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 0;
}

.vcode-input > input[type=text]:focus {
    box-shadow: none;
}

.vcode-input > input[type=text]:placeholder-shown + label {
  color: #aaa;
  font-size: 14px;
  left: 5px;
  top: 5px;
}
</style>